import React, { useState, useEffect } from 'react';

const NAV_LINKS = [
  { href: '#about',        label: 'About' },
  { href: '#projects',     label: 'Work' },
  { href: '#experience',   label: 'Experience' },
  { href: '#skills',       label: 'Skills' },
  { href: '#achievements', label: 'Research' },
  { href: '#contact',      label: 'Contact' },
];

export default function Navbar({ dark, onOpenRecruiter }) {
  const [scrolled, setScrolled]   = useState(false);
  const [active,   setActive]     = useState('');
  const [menuOpen, setMenuOpen]   = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  /* Highlight active section */
  useEffect(() => {
    const ids = NAV_LINKS.map(l => l.href.slice(1));
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => e.isIntersecting && setActive(e.target.id)),
      { rootMargin: '-40% 0px -55% 0px' }
    );
    ids.forEach(id => { const el = document.getElementById(id); if (el) obs.observe(el); });
    return () => obs.disconnect();
  }, []);

  const close = () => setMenuOpen(false);

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 500,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: scrolled ? '0 60px' : '0 60px',
        height: scrolled ? 56 : 68,
        background: scrolled ? 'var(--card-bg)' : 'transparent',
        borderBottom: `1px solid ${scrolled ? 'var(--border-color)' : 'transparent'}`,
        backdropFilter: scrolled ? 'blur(22px)' : 'none',
        transition: 'height 0.3s, background 0.3s, border-color 0.3s',
      }}>

        {/* Logo- wordmark only, no icon */}
        <a href="#hero" style={{
          fontFamily: 'var(--bebas)',
          fontSize: 22,
          letterSpacing: '5px',
          color: 'var(--accent-color)',
          textDecoration: 'none',
          cursor: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          userSelect: 'none',
        }}>
          VG
          <span style={{
            fontFamily: 'var(--mono)',
            fontSize: 8,
            letterSpacing: '2px',
            color: 'var(--text-muted)',
            fontWeight: 400,
            marginTop: 2,
            paddingLeft: 8,
            borderLeft: '1px solid var(--border-color)',
          }}>FULL STACK + AI</span>
        </a>

        {/* Desktop nav */}
        <ul style={{ display: 'flex', gap: 0, listStyle: 'none', alignItems: 'center' }} className="nav-desktop">
          {NAV_LINKS.map(l => {
            const isActive = active === l.href.slice(1);
            return (
              <li key={l.href}>
                <a href={l.href} style={{
                  fontFamily: 'var(--mono)',
                  fontSize: 9,
                  letterSpacing: '2px',
                  color: isActive ? 'var(--accent-color)' : 'var(--text-muted)',
                  textDecoration: 'none',
                  textTransform: 'uppercase',
                  padding: '0 16px',
                  height: scrolled ? 56 : 68,
                  display: 'flex', alignItems: 'center',
                  borderBottom: isActive ? '1px solid var(--accent-color)' : '1px solid transparent',
                  transition: 'color 0.2s, border-color 0.2s',
                  cursor: 'none',
                  position: 'relative',
                }}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.color = 'var(--accent-color)'; }}
                onMouseLeave={e => { if (!isActive) e.currentTarget.style.color = 'var(--text-muted)'; }}>
                  {l.label}
                </a>
              </li>
            );
          })}
        </ul>

 {/* Right actions */}
<div style={{ display: 'flex', alignItems: 'center', gap: 8 }} className="nav-desktop">
  {/* Resume */}
  <a href="https://drive.google.com/file/d/1pK0nLPePrEtZkrpqajLdGeJlG9Khs2Rt/view?usp=drive_link"
    target="_blank" rel="noreferrer"
    className="nav-resume-btn"
    style={{
      fontFamily: 'var(--mono)', fontSize: 9, letterSpacing: '2px',
      color: 'var(--accent-color)', textDecoration: 'none', textTransform: 'uppercase',
      border: '1px solid var(--accent-color)', background: 'transparent',
      padding: '0 14px', height: 32, borderRadius: 3,
      display: 'flex', alignItems: 'center',
      transition: 'all 0.22s', cursor: 'none',
    }}
    onMouseEnter={e => { e.currentTarget.style.background = 'var(--accent-color)'; e.currentTarget.style.color = 'var(--bg)'; }}
    onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--accent-color)'; }}
  >Resume ↗</a>

  {/* Hire Me- with same spinning border animation as Available Now */}
  <div className="av-wrap" style={{ marginLeft: 4 }}>
    <div className="av-pulse" />
    <div className="av-pulse" />
    <button onClick={onOpenRecruiter} className="av-btn" style={{ background: 'none', border: 'none', cursor: 'none' }}>
      <div className="av-border" />
      <div className="av-bg" />
      <div className="av-sheen" />
      <span className="av-label">
        <span className="av-dot" />
For Recruiters
      </span>
    </button>
  </div>
</div>

        {/* Hamburger */}
        <button
          className="hamburger"
          style={{ display: 'none', flexDirection: 'column', gap: '5px', background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
          onClick={() => setMenuOpen(o => !o)} aria-label="Menu"
        >
          <span style={{ width: 22, height: 1.5, background: 'var(--text-primary)', display: 'block', transition: 'all 0.28s', transform: menuOpen ? 'rotate(45deg) translate(4.5px, 4.5px)' : 'none' }} />
          <span style={{ width: 22, height: 1.5, background: 'var(--text-primary)', display: 'block', transition: 'all 0.28s', opacity: menuOpen ? 0 : 1 }} />
          <span style={{ width: 22, height: 1.5, background: 'var(--text-primary)', display: 'block', transition: 'all 0.28s', transform: menuOpen ? 'rotate(-45deg) translate(4.5px, -4.5px)' : 'none' }} />
        </button>
      </nav>

      {/* Mobile drawer */}
      {menuOpen && (
        <div style={{
          position: 'fixed', top: 56, left: 0, right: 0, bottom: 0,
          background: 'var(--card-bg)', backdropFilter: 'blur(24px)',
          borderTop: '1px solid var(--border-color)',
          padding: '2rem 1.5rem',
          zIndex: 498,
          display: 'flex', flexDirection: 'column', gap: 0,
          overflowY: 'auto',
        }}>
          {NAV_LINKS.map(l => (
            <a key={l.href} href={l.href}
              style={{
                fontFamily: 'var(--bebas)', fontSize: 28, letterSpacing: '2px',
                textDecoration: 'none', color: 'var(--text-primary)',
                padding: '14px 0', borderBottom: '1px solid var(--border-color)',
                transition: 'color 0.2s',
              }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--accent-color)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--text-primary)'}
              onClick={close}
            >{l.label}</a>
          ))}

          <div style={{ marginTop: 28, display: 'flex', flexDirection: 'column', gap: 10 }}>
            <a href="https://drive.google.com/file/d/1pK0nLPePrEtZkrpqajLdGeJlG9Khs2Rt/view?usp=drive_link"
              target="_blank" rel="noreferrer"
              style={{
                fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: '2px', textTransform: 'uppercase',
                textDecoration: 'none', color: 'var(--accent-color)',
                border: '1px solid var(--accent-color)', padding: '12px 16px',
                textAlign: 'center', borderRadius: 3,
              }}
              onClick={close}>Resume ↗</a>
<button
  style={{
    fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: '2px', textTransform: 'uppercase',
    color: 'var(--accent-color)', border: '1px solid var(--accent-color)',
    padding: '12px 16px', background: 'transparent', borderRadius: 3,
    cursor: 'pointer', width: '100%',
  }}
  onClick={() => { close(); onOpenRecruiter(); }}>For Recruiters</button>
            <a href="mailto:gautam7.ven@gmail.com"
              style={{
                fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: '2px', textTransform: 'uppercase',
                textDecoration: 'none', color: 'var(--bg)',
                background: 'var(--accent-color)', padding: '12px 16px',
                textAlign: 'center', borderRadius: 3,
              }}
              onClick={close}>Available Now</a>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 960px) {
          .nav-desktop { display: none !important; }
          .hamburger   { display: flex !important; }
          nav { padding: 0 1.25rem !important; }
        }
      `}</style>
    </>
  );
}